import { render, staticRenderFns, recyclableRender, components } from "./s-list-form.vue?vue&type=template&id=d644fb6a&scoped=true&"
var renderjs
import script from "./s-list-form.vue?vue&type=script&lang=js&"
export * from "./s-list-form.vue?vue&type=script&lang=js&"
import style0 from "./s-list-form.vue?vue&type=style&index=0&id=d644fb6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!E:\\前端软件\\HBuilderX.3.2.12.20211029\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d644fb6a",
  null,
  false,
  components,
  renderjs
)

export default component.exports